import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CommunicationOverview, CommunicationTrendPoint, TimePatternPoint } from '@app/core/api/communication-analytics';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';

export const CommunicationAnalyticsActions = createActionGroup({
  source: 'Communication Analytics',
  events: {
    'Load Overview': props<{ params: AnalyticsQueryParams }>(),
    'Load Overview Success': props<{ overview: CommunicationOverview }>(),
    'Load Overview Failure': props<{ error: string }>(),

    'Load Trend': props<{ params: AnalyticsTrendQueryParams }>(),
    'Load Trend Success': props<{ trend: CommunicationTrendPoint[] }>(),
    'Load Trend Failure': props<{ error: string }>(),

    'Load Time Pattern': props<{ params: AnalyticsQueryParams }>(),
    'Load Time Pattern Success': props<{ timePattern: TimePatternPoint[] }>(),
    'Load Time Pattern Failure': props<{ error: string }>(),

    'Clear Communication Analytics State': emptyProps(),
  }
});
